<template>
  <section class="new-interface-roundtable position-relative rt-three-bg">
    <div class="masterfull-planning-btn d-flex justify-content-end">
      <div class="blac-trans-bg" @click.stop="drawer = !drawer">
        <span class="border-right"
          ><i class="fa fa-angle-right pr-3"></i> Big Day Planners</span
        >
        <span>
          <v-icon color="#fff" size="20px">mdi-account-outline</v-icon>
          7/50</span
        >
      </div>
    </div>
    <!-- theme change icon start -->
    <div class="exporight-panel">
      <v-btn
        raised
        color="rgba(0,0,0,0.7)"
        width="45px"
        min-width="45px"
        height="40px"
        class="mb-2 expo-panel-butn"
        ><img
          src="../../assets/Images/new-design-icons/booth-list.svg"
          style="height: 25px; width: 25px"
      /></v-btn>
      <v-btn
        raised
        color="rgba(0,0,0,0.7)"
        width="45px"
        min-width="45px"
        height="40px"
        class="mb-2 expo-panel-butn"
        @click="templateListDialog()"
        ><img
          src="../../assets/Images/new-design-icons/template.svg"
          style="height: 25px; width: 25px"
      /></v-btn>
    </div>
    <!-- theme change icon end -->
    <!--lobby avatar---->
    <div class="bubble-attendee position-absolute lobby-att-pre">
      <div class="attendee-presence blink" @click.stop="toggle = !toggle">
        <img
          class="presence-image"
         src="../../assets/Images//attendee.png"/>

      </div>
     
    </div>
    <!--lobby avatar end---->
     
    <!-- change theme modal start -->
    <v-dialog v-model="templateList" width="630px">
      <v-card class="p-3 lobby-change-bg">
        <div
          class="
            dialog-header
            d-flex
            justify-content-between
            align-items-center
          "
        >
          <h3 class="pl-4">Change Background</h3>
          <v-btn
            elevation="3"
            color="#fff"
            fab
            small
            @click="templateList = false"
          >
            <v-icon color="#000000" size="25px">mdi-close</v-icon>
          </v-btn>
        </div>
        <template>
          <v-tabs v-model="tab2" align-with-title class="template-tabs-head">
            <v-tabs-slider color="#000"></v-tabs-slider>
            <v-tab class="ml-0">Gallery</v-tab>
            <v-tab>Upload</v-tab>
            <v-tab>Link to Image</v-tab>
          </v-tabs>
        </template>
        <v-tabs-items v-model="tab2">
          <v-tab-item>
            <div class="template-list-hld">
              <v-row>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-1.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-2.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-3.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-2.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-1.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-3.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-1.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-2.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-3.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-1.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-3.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-1.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-2.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-interface/roundtable-3.png"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="template-list-hld">
              <v-row>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_00_105Z.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_05_514Z.png"
                    />
                  </div>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_25_242Z.png"
                    />
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_39_353Z.png"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div class="template-list-hld">
              <v-row>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_00_105Z.png"
                    />
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_05_514Z.png"
                    />
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_25_242Z.png"
                    />
                  </div>
                </v-col>
                <v-col md="4" sm="6" cols="12">
                  <div class="single-choice-template">
                    <img
                      src="../../assets/Images/new-design-icons/image_2022_07_25T09_11_39_353Z.png"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
    <!-- change theme modal end -->
    <!---mastgerfull Planning Drower start--->
    <v-navigation-drawer
      absolute
      temporary
      right
      v-model="drawer"
      color="#0e0f12"
      class="mastgerfull-planning-drawer"
      width="360"
    >
    <div class="d-flex align-items-center justify-content-between rt-search">
    <h2>Rooms</h2>
    <v-btn icon>
        <v-icon size="23" color="#fff">mdi-magnify</v-icon>
      </v-btn>
      </div>
      <v-expansion-panels focusable >
        <v-expansion-panel >
          <v-expansion-panel-header
            >Masterful Planning 7/50</v-expansion-panel-header
          >
          <v-expansion-panel-content class="px-0">
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
         <v-expansion-panel >
          <v-expansion-panel-header
            >Big Day Planners 7/50</v-expansion-panel-header
          >
          <v-expansion-panel-content class="px-0">
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
         <v-expansion-panel >
          <v-expansion-panel-header
            >Happy Guest 7/50</v-expansion-panel-header
          >
          <v-expansion-panel-content class="px-0">
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
         <v-expansion-panel >
          <v-expansion-panel-header
            >Evident Excellence 7/50</v-expansion-panel-header
          >
          <v-expansion-panel-content class="px-0">
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
            <div class="media align-items-center">
              <img
                class="align-self-center mr-3 "
                src="../../assets/Images/attendee.png"
                alt="Generic placeholder image"
              />
              <div class="media-body">
                <h5 class="m-0">Linda Hughes</h5>
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-navigation-drawer>
    <!---mastgerfull Planning Drower end--->
  </section>
</template>
<script>
var self;
export default {
  data() {
    return {
      toggle: false,
      tab2: null,
      templateList: false,
      drawer: null,
    };
  },
  created() {
    self = this;
  },
  methods: {
    templateListDialog() {
      self.templateList = true;
    },
  },
};
</script>


